import React, { useState, useEffect } from 'react'
import { useSearchParams, Link } from 'react-router-dom'
import { SEOHead } from '../components/ui/SEOHead'
import { TerminalWindow } from '../components/terminal/TerminalWindow'
import { LoadingSpinner } from '../components/ui/LoadingSpinner'
import { subscribersApi } from '../api/subscribersApi'

type State = 'loading' | 'unsubscribed' | 'invalid' | 'error'

export const SubscribeUnsubscribePage: React.FC = () => {
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''
  const [state, setState] = useState<State>(token ? 'loading' : 'invalid')

  useEffect(() => {
    if (!token) return
    subscribersApi
      .unsubscribe(token)
      .then((res) => setState(res.success ? 'unsubscribed' : 'invalid'))
      .catch(() => setState('error'))
  }, [token])

  return (
    <>
      <SEOHead title="Unsubscribing" />
      <TerminalWindow title="unsubscribe.sh">
        <div
          style={{
            fontFamily: "'JetBrains Mono', 'Courier New', monospace",
            fontSize: '0.9rem',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}
        >
          {state === 'loading' && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'var(--text-secondary)' }}>
              <LoadingSpinner />
              <span>processing unsubscribe request...</span>
            </div>
          )}

          {state === 'unsubscribed' && (
            <>
              <div style={{ color: 'var(--accent-amber)' }}>✓ You&apos;ve been unsubscribed.</div>
              <div style={{ color: 'var(--text-secondary)' }}>
                You won&apos;t receive any more emails from CodeToByte.
              </div>
              <Link to="/" style={{ color: 'var(--accent-blue)', fontSize: '0.85rem' }}>
                [← back to home]
              </Link>
            </>
          )}

          {state === 'invalid' && (
            <>
              <div style={{ color: 'var(--accent-red, #ff4444)' }}>
                Error: The unsubscribe link is invalid or has already been used.
              </div>
              <Link to="/" style={{ color: 'var(--accent-blue)', fontSize: '0.85rem' }}>
                [← back to home]
              </Link>
            </>
          )}

          {state === 'error' && (
            <>
              <div style={{ color: 'var(--accent-red, #ff4444)' }}>
                Error: Something went wrong. Please try again later.
              </div>
              <Link to="/" style={{ color: 'var(--accent-blue)', fontSize: '0.85rem' }}>
                [← back to home]
              </Link>
            </>
          )}
        </div>
      </TerminalWindow>
    </>
  )
}
